import React, { useState } from 'react';
import styles from './styles/toggle.scss';
import checkCircle from '../../assets/images/check-circle.svg';
import classNames from 'classnames';

type ToggleProps = {
  leftText: string;
  rightText: string;
  selectedIndex: number;
  onChange?: (index: number) => void;
  style?: React.CSSProperties;
};

const Toggle: React.FC<ToggleProps> = ({ leftText, rightText, onChange, style, selectedIndex }) => {
  const handleToggle = (index: number) => {
    if (onChange) {
      onChange(index);
    }
  };

  return (
    <div className={styles.toggleContainer} style={style}>
      <button
        onClick={() => handleToggle(0)}
        className={classNames(styles.toggleBtn, styles.leftBtn, selectedIndex === 0 ? styles.selected : '')}
      >
        {leftText}
        {selectedIndex === 0 && <img src={checkCircle} alt="Check Circle" className={styles.checkIcon} />}
      </button>
      <button
        onClick={() => handleToggle(1)}
        className={classNames(styles.toggleBtn, styles.rightBtn, selectedIndex === 1 ? styles.selected : '')}
      >
        {rightText}
        {selectedIndex === 1 && <img src={checkCircle} alt="Check Circle" className={styles.checkIcon} />}
      </button>
    </div>
  );
};

export default Toggle;
